import { login } from "../auth/auth.js";

export function loginView(root: HTMLElement): void {
  root.innerHTML = `
    <nav class="site-nav">
      <div class="nav-container">
        <span class="logo"><span class="b">Bright Mind</span> <span class="g">Tech</span></span>
      </div>
    </nav>
    <div class="login-view">
      <div class="login-container">
        <h1>SharePoint</h1>
        <p>Securely access your study guides, documents, and quizzes.</p>
        <div class="login-card">
          <h2>Welcome</h2>
          <p>Sign in with your Bright Mind Tech account to continue.</p>
          <button class="btn-signin" id="login">Sign In</button>
        </div>
      </div>
    </div>`;
  root.querySelector<HTMLButtonElement>("#login")?.addEventListener("click", () => {
    void login();
  });
}
